import qs from 'query-string'
import {
  cookie,
  constants,
  canUseDOM,
  RequestError
} from '@pmi/pmi-iqos-shared-react'

// this function is declared outside the async/await because of a bug on regenerators which are unable to implement dead code elimination when paired with webpack
// https://github.com/babel/babel/issues/7665
function getMockDataIfNecessary(mock, url) {
  let resultData = null
  const isLocalhost = canUseDOM && window.location.hostname === 'localhost'
  const urlParms = canUseDOM ? qs.parse(window.location.search) : {}
  const isSSRMock =
    typeof process !== 'undefined' && process.env.MOCK === 'true'
  if (mock && ((isLocalhost && urlParms.mock === 'true') || isSSRMock)) {
    console.log('Get mock for: ', url, '\nFile: ', mock)
    const defaultRes = { error: 'NO MOCK DATA AVAILABLE' }
    const mockedResponse = require(`../../mocks/${mock}`)
    resultData = mockedResponse || defaultRes
  }
  return resultData
}
export default class Qure {
  constructor(api) {
    this.api = api
  }

  async makeRequest({
    url,
    method = 'get',
    headers = {},
    data = null,
    mock = null,
    withCredentials = false,
    faq = false
  }) {
    const mockData = getMockDataIfNecessary(mock, url)
    if (mockData) return mockData

    var opts = {
      headers: {
        'X-AUTH-APPLICATION-ID': faq
          ? constants.FAQ_APPLICATION_ID
          : constants.QURE_APPLICATION_ID,
        'X-AUTH-SECRET-KEY': faq
          ? constants.FAQ_SECRET_KEY
          : constants.QURE_SECRET_KEY,
        'X-AUTH-SPICE-ID': cookie.getSpiceId(),
        'X-TRACK-ACTION': constants.QURE_TRACK_ACTION,
        'CONTENT-TYPE': 'application/json',
        ...headers
      },
      withCredentials
    }
    if (data) {
      opts.data = data
    }
    try {
      const res = await this.api[method](url, opts)
      if (res.data && res.data.token) {
        cookie.setQureToken(res.data.token)
      }
      if (res.status === 'success') {
        // the request was successful, return the entire response
        return res
      }
      if (res.status === 'error') {
        // Somenthing wrong happened, we do not know what, so we treat it as a generic error
        // err.data will be null
        throw new RequestError('Internal Server Error', 500, null, opts)
      }
      if (res.status === 'fail') {
        // Somenthing wrong happen,
        // err.data will contain reasonCode and defectedCode
        throw new RequestError('Internal Server Error', 500, res.data, opts)
      }
      return res
    } catch (err) {
      console.error(
        `An error has occourred - ${err.status}: ${err.message}`,
        err.data
      )

      // In case of unknown error (regardless of the status code), we throw a 500 error
      throw new RequestError('Internal Server Error', 500, err.data, opts)
    }
  }

  getQureInitialStatus = async (codentify, faq = false) => {
    const res = await this.makeRequest({
      url: '/qure/initialstatus/' + codentify,
      headers: {
        ...cookie.authorizationTokenHeader(null, true)
      },
      method: 'get',
      data: {},
      faq
    })
    return res
  }

  getQureDefectedCodeUI = async (deviceType, path) => {
    const res = await this.makeRequest({
      url: '/qure/defectedcodeui/' + deviceType + '/' + path,
      headers: {
        ...cookie.authorizationTokenHeader(null, true)
      },
      method: 'get',
      data: {}
    })
    return res
  }

  getQureReplacementData = async (codentify, defectedCode, faq = false) => {
    const res = await this.makeRequest({
      url: '/qure/replacementdata/' + codentify + '/' + defectedCode,
      method: 'get',
      data: {},
      headers: {
        'LANG-CODE': 'ja',
        ...cookie.authorizationTokenHeader(null, true)
      },
      faq,
      mock: this.api.getMock('getQureReplacementData')
    })
    return res
  }

  getQureEligibility = async (codentify, defectedCode, faq = false) => {
    const res = await this.makeRequest({
      url: '/qure/eligibility/' + codentify + '/' + defectedCode,
      method: 'get',
      data: {},
      headers: {
        'LANG-CODE': 'ja',
        ...cookie.authorizationTokenHeader(null, true)
      },
      faq,
      mock: this.api.getMock('getQureEligibility')
    })
    return res
  }

  getQureValidateZipCode = async (postalCode, faq = false) => {
    const res = await this.makeRequest({
      url: '/qure/validatezipcode/' + postalCode,
      method: 'get',
      data: {},
      headers: {
        'LANG-CODE': 'ja',
        ...cookie.authorizationTokenHeader(null, true)
      },
      faq,
      mock: this.api.getMock('getQureValidateZipCode')
    })
    return res
  }

  createReplacementOrder = async (opts, faq = false) => {
    const res = await this.makeRequest({
      url: '/qure/replacement',
      withCredentials: true,
      method: 'post',
      data: {
        ...opts
      },
      headers: {
        'LANG-CODE': 'ja',
        ...cookie.authorizationTokenHeader(null, true)
      },
      faq,
      mock: this.api.getMock('createReplacementOrder')
    })
    return res
  }
}
